import React, { useEffect, useState } from 'react';
import { slide as Menu } from 'react-burger-menu';
import { useSelector } from 'react-redux';
import { withResizeDetector } from 'react-resize-detector';
import {
  BrowserRouter,
  Redirect,
  Route,
  Switch,
  useLocation,
} from 'react-router-dom';

import config from 'config';

import Header from 'components/bars/Header';
import SideMenuNav from 'components/bars/SideMenuNav';
import SaveDiscardToast from 'components/base/SaveDiscardToast';
import routes from 'config/Routes';
import Login from 'containers/user/Login';
import ShopifyLogin from 'containers/user/ShopifyLogin';
import { FIRST_TIME_ENTER_CAMPAIGN } from 'models/CampaignListModel';

import { saveToSessionStorage } from 'utils';

import './App.scss';
import 'antd/dist/antd.css';

function PageRoute({ width, height }) {
  const [openMenu, setOpenMenu] = useState(false);
  const user = useSelector((state) => state.users);
  const [appRoutes, setAppRoutes] = useState();
  const location = useLocation();
  useEffect(() => {
    setAppRoutes(routes(user));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [user.isSuperuser, user.userPermissions]);

  useEffect(() => {
    const pathname = location.pathname;
    if (!pathname.includes('campaigns')) {
      saveToSessionStorage(FIRST_TIME_ENTER_CAMPAIGN, false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location]);

  useEffect(() => {
    if (width > 750 && openMenu) {
      setOpenMenu(false);
    }
  }, [width, openMenu]);

  if (user.isLogin) {
    const useSideMenu = width <= 750;
    return (
      <div className="main-container">
        <div className="main-content">
          {useSideMenu ? (
            <Menu
              isOpen={openMenu}
              onStateChange={(state) => {
                setOpenMenu(state.isOpen);
              }}
              width={240}
              styles={{
                bmCross: {
                  height: 25.6,
                },
                bmCrossButton: {
                  right: 0,
                  top: 14,
                  width: 32,
                  height: 32,
                  left: openMenu ? 254 : 0,
                },
              }}
            >
              <div
                className="sidebar-container"
                style={{
                  backgroundColor: config.sidePanelColor,
                }}
              >
                <SideMenuNav />
              </div>
            </Menu>
          ) : null}
          <Header />
          <Switch>{appRoutes}</Switch>
        </div>
        {useSideMenu ? null : (
          <div
            className="sidebar-container"
            style={{
              backgroundColor: config.sidePanelColor,
            }}
          >
            <SideMenuNav />
          </div>
        )}
      </div>
    );
  } else {
    return <Redirect to="/login" />;
  }
}

const SizeDetectPageRoute = withResizeDetector(PageRoute);

function App() {
  return (
    <BrowserRouter>
      <SaveDiscardToast />
      <Switch>
        <Route path="/login">
          <Login />
        </Route>
        <Route path="/shopify_login">
          <ShopifyLogin />
        </Route>
        <Route>
          <SizeDetectPageRoute />
        </Route>
      </Switch>
    </BrowserRouter>
  );
}

export default App;
